<template>
  <div class="report-detail-container">
    <header class="header-content">
      <!-- <p class="slogan-en">EXCEL AND BEYOND</p> -->
      <h1 class="main-title">卓越进取 <span class="divider">|</span> 成就非凡</h1>
    </header>

    <section class="data-section">
      <p class="intro-text">2026年8月学习成就总结</p>
      
      <div class="stats-grid">
        <div class="stat-card" v-show="ReportData.coursenumMon">
          <span class="label">学习课程<a class="number">{{ ReportData.coursenumMon }}</a>门</span>
        </div>

        <div class="stat-card" v-show="ReportData.creditvalue">
          <span class="label">获得学分<a class="number">{{ ReportData.creditvalue }}</a>个</span>
        </div>

        <div class="stat-card" v-show="ReportData.examTimes">
          <span class="label">累计考试<a class="number">{{ ReportData.examTimes  }}</a>次</span>
        </div>
      </div>

      <!-- <div class="ranking-box" >
        <p>超越了 <span class="highlight">{{ ReportData.rate2 }}%</span> 的同行小伙伴</p>
        <div class="progress-track">
          <div class="progress-bar" :style="{ width: ReportData.rate2 + '%' }"></div>
        </div>
      </div> -->

      <div class="motivation-footer">
        <p>每一次超越都是对极限的突破</p>
        <p>继续前行，潜力无限</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["ReportData"],
}
</script>

<style scoped>
/* 定义配色变量 */
:root {
  --deep-red: #8B2C2A;       /* 深红褐色，用于文字 */
  --accent-gold: #D4A373;   /* 琥珀金，用于修饰 */
  --card-white: rgba(255, 255, 255, 0.45); /* 半透明卡片 */
}

.report-detail-container {
	width: 100%;
	height: 100vh;
	background: 
			linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url("../../assets/26May/logo.png") right top no-repeat,
			url("../../assets/26August/bg.jpg") no-repeat;
	background-size: cover, 100% 100%, cover;
	color: #000; /* 深褐色文字，与粉色背景最搭 */
	padding: 0 10%;
	box-sizing: border-box;
	overflow: hidden;
}

/* 顶部样式 */
.header-content {
  padding-top: 8vh;
  margin-bottom: 4vh;
}

.slogan-en {
  font-size: 12px;
  letter-spacing: 3px;
  color: #2c7709;
  opacity: 0.6;
  margin-bottom: 5px;
}

.main-title {
  font-size: 24px;
  font-weight: 800;
  margin: 0;
  color: #008777;
  display: flex;
  align-items: center;
}

.divider {
  margin: 0 10px;
  color: #8a5a2b;
  font-weight: 200;
}

/* 数据区域 */
.intro-text {
  font-size: 1.1rem;
  margin-bottom: 25px;
  opacity: 0.8;
}

.stats-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 18px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.label {
  font-size: 16px;
  font-weight: 500;
}

.value-wrapper {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.number {
  font-size: 32px;
  font-weight: 900;
  color: #008777;
  font-family: 'Arial Black', sans-serif;
}

.unit {
  font-size: 14px;
  color: #008777;
  opacity: 0.7;
}

/* 排名区域 */
.ranking-box {
  margin-top: 30px;
  background: rgba(139, 44, 42, 0.05);
  padding: 20px;
  border-radius: 12px;
}

.highlight {
  font-size: 24px;
  font-weight: bold;
  color: #7c5dd9;
}

.progress-track {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  margin-top: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #D4A373, #7c5dd9);
  border-radius: 10px;
}

/* 底部寄语 */
.motivation-footer {
  margin-top: 40px;
  text-align: left;
}

.motivation-footer p {
  font-size: 16px;
  margin: 5px 0;
  font-weight: 600;
}

.motivation-footer .sub {
  font-size: 14px;
  opacity: 0.7;
  font-weight: 400;
}

@media screen and (min-width: 786px) {
    .report-detail-container {
        background-image: url("../../assets/26August/bg.jpg");
        background-size: cover;
    }

}
</style>